import problemImage from "../assets/Problem.png";

const ProblemSection = () => {
  return (
    <section className="bg-white border-t border-[#EAEAEA]">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32">
        <img
          src={problemImage}
          alt="The Problem: The creator economy is growing, but most creators are excluded due to visibility bias, algorithmic inequality, limited access to collaborations, and broken or inaccessible monetization and payment systems. Issues include: No Creator Support, Monetization Unavailable, No Collaboration yet, Unfair rewards, Low Reach, Low Engagement, Creative Burnout, No Visibility, Algorithm Bias, Only Big Creators win, No Ownership."
          className="w-full h-auto object-contain"
        />
      </div>
    </section>
  );
};

export default ProblemSection;
